import { useEffect } from "react";
import BannerTwo from "../HomePage/Technology/AllBanner/BannerTwo";
import UiUxMain from "./TechnologiesUiUxPage/UiUxMain";
import FooterContact from "../FooterContactPage/FooterContact";
import { Helmet } from "react-helmet-async";

const TechUI = () => {
  useEffect(() => {
      window.scrollTo(0, 0);
    }, []);
  return (
    <div>
      <Helmet>
        <title>User Focused UI UX Design Services | Quad Theory Ltd</title>
        <meta
          name="description"
          content="Quad Theory Ltd offers UI and UX design services focused on clarity, usability, and real user behaviour. We design interfaces that reduce friction, improve flow, and support products."
        />
      </Helmet>
      <BannerTwo />
      <UiUxMain />
      {/* form component yeameen */}
      <FooterContact />
    </div>
  );
};

export default TechUI;
